import { TerminalType } from "@/shared/types/userTerminalTypes";
import { TailwindColorKey, resolveTailwindColorKey, getBadgeColorClasses, getTextColorClass, getChartFill } from "./color-utils";

export const TERMINAL_TYPE_INFO: Record<TerminalType, { key: TerminalType; color: TailwindColorKey; value: string; sortOrder: number }> = {
    [TerminalType.STARLINK_PERFORMANCE_GEN_3]: {
        key: TerminalType.STARLINK_PERFORMANCE_GEN_3,
        color: 'indigo',
        value: 'Starlink Performance (Gen 3)',
        sortOrder: 1,
    },
    [TerminalType.STARLINK_PERFORMANCE_GEN_2]: {
        key: TerminalType.STARLINK_PERFORMANCE_GEN_2,
        color: 'orange',
        value: 'Starlink Performance (Gen 2)',
        sortOrder: 2,
    },
    [TerminalType.STARLINK_ENTERPRISE_V4]: {
        key: TerminalType.STARLINK_ENTERPRISE_V4,
        color: 'blue',
        value: 'Starlink Enterprise V4',
        sortOrder: 3,
    },
    [TerminalType.STARLINK_MINI]: {
        key: TerminalType.STARLINK_MINI,
        color: 'purple',
        value: 'Starlink Mini',
        sortOrder: 4,
    },
    [TerminalType.STARLINK_STANDARD_4]: {
        key: TerminalType.STARLINK_STANDARD_4,
        color: 'green',
        value: 'Starlink Standard 4',
        sortOrder: 5,
    },
    [TerminalType.STARLINK_STANDARD_4X]: {
        key: TerminalType.STARLINK_STANDARD_4X,
        color: 'yellow',
        value: 'Starlink Standard 4X',
        sortOrder: 6,
    },
    [TerminalType.NOT_SET]: {
        key: TerminalType.NOT_SET,
        color: 'gray',
        value: 'Not Set',
        sortOrder: 7,
    },
};

export const getTerminalTypeColorKey = (type: TerminalType): TailwindColorKey => {
    const info = TERMINAL_TYPE_INFO[type];
    return resolveTailwindColorKey(info.color);
}

export const getTerminalTypeBGColorClass = (type: TerminalType): string =>
    getBadgeColorClasses(getTerminalTypeColorKey(type));

export const getTerminalTypeTextColorClass = (type: TerminalType): string =>
    getTextColorClass(getTerminalTypeColorKey(type));

export const getTerminalTypeChartFill = (type: TerminalType): string =>
    getChartFill(getTerminalTypeColorKey(type));